import { FC } from 'react';

import { NewNotificationsBanner } from './notifications.styles';
import { IRefreshNotificationsButton } from './notifications.types';

const RefreshNotificationsButton: FC<IRefreshNotificationsButton> = ({
  newNotificationsCount,
  onClick,
}) => (
  <NewNotificationsBanner onClick={onClick}>
    {newNotificationsCount} new notification
    {newNotificationsCount > 1 ? 's' : ''} — click to refresh
  </NewNotificationsBanner>
);

export default RefreshNotificationsButton;
